var angular = require('angular');
require('angular-chart.js');

export default angular
    .module('asDoughnutChart', ['chart.js'])
    .component('asDoughnutChart', {
        template: require('./asDoughnutChart.component.html'),
        styleUrls: require('./asDoughnutChart.component.css'),
        controller: ['entitlementConstants', asDoughnutChartComponent],
        bindToController: true,
        bindings: {
            donut: '<'
        }
    });

function asDoughnutChartComponent(entitlementConstants) {
    var vm = this;
    vm.$onChanges = change;
    vm.data = angular.copy(vm.data);

    vm.tooltip = {
        title: '',
        content: ''
    };
    vm.showTotalOverall = true;

    function render() {
        vm.showTotalOverall = true;
        vm.options = {
            tooltips: false,
            cutoutPercentage: 75,
            responsive: true
        };

        if (vm.donut != null) {
            vm.labels = ['used', 'allocated'];

            var usedColor = vm.donut.color;
            var unusedColor = '#e9f0f6';

            vm.datasets = {
                borderWidth: [0, 0],
                hoverBorderWidth: [0, 0],
                hoverBackgroundColor: [usedColor, unusedColor]
            };

            // Calculate the total overall
            if (vm.donut.total > 0) {
                vm.totalOverall = vm.donut.total;
            } else {
                vm.totalOverall = vm.donut.cals;
            }
            // Calculate the percentage
            vm.decimalPercentage = (vm.donut.usage / vm.totalOverall) * 100;
            vm.percentage = ((vm.donut.usage / vm.totalOverall) * 100).toFixed(
                0
            );
            vm.innerChartPercentage = vm.percentage + '%';

            // Calculate Balance and update the array
            vm.balance = vm.totalOverall - vm.donut.usage;

            // Set the colors
            vm.colors = [usedColor, unusedColor];
            vm.data = [vm.donut.usage, vm.balance];

            // if subscription is active
            if (vm.donut.total > 0) {
                vm.showSubscription = true;

                // if balance is 0 / 100% fully utilized
                if (vm.balance == 0) {
                    vm.colors = [usedColor, usedColor];
                    vm.data = [vm.donut.usage];
                    vm.noBalance = true;
                } else if (vm.balance < 0) {
                    // if balance is less than 0 / overusage
                    vm.innerChartPercentage = '>' + 100 + '%';
                    vm.datasets = {
                        borderWidth: [0, 0],
                        hoverBorderWidth: [0, 0],
                        hoverBackgroundColor: [usedColor, unusedColor]
                    };
                    vm.data = [vm.donut.usage];
                    vm.showRedText = true;
                    vm.noBalance = true;
                    vm.colors = [usedColor, unusedColor];
                }
            }

            // If usage is between 0% and <1% value
            if (vm.decimalPercentage > 0 && vm.decimalPercentage < 1) {
                vm.innerChartPercentage = '<' + 1 + '%';
                vm.data = [vm.donut.usage, vm.balance];
            }

            if (
                vm.donut.chartTitle != entitlementConstants.devices &&
                vm.donut.chartTitle != entitlementConstants.platformUsers &&
                vm.donut.unit != '' &&
                vm.donut.usage > 0 &&
                vm.donut.usage < 1
            ) {
                vm.donut.usage = '< 1';
            }

            // If usage and total are 0 or null/ inner percentage is NaN or Infinity
            if (
                !isFinite(vm.percentage) ||
                (vm.donut.usage == 0 && vm.donut.total == 0) ||
                vm.donut.usage == null ||
                vm.donut.total == null ||
                vm.donut.usage <= -1 ||
                vm.donut.total <= -1
            ) {
                vm.showSubscription = true;
                vm.showTotalOverall = false;
                vm.innerChartPercentage = vm.donut.usage == null ? 'N/A' : 0;
                vm.balance = 100;
                vm.totalOverall = vm.donut.usage == null ? 'n/a' : 0;
                vm.donut.usage = vm.donut.usage == null ? 'n/a' : 0;
                vm.donut.total = vm.donut.usage == null ? 'n/a' : 0;
                vm.datasets = {
                    borderWidth: [0, 0],
                    hoverBorderWidth: [0, 0],
                    backgroundColor: [unusedColor, unusedColor],
                    hoverBackgroundColor: [unusedColor, unusedColor]
                };
                vm.data = [vm.donut.usage, vm.balance];
                vm.colors = [unusedColor, unusedColor];
            }

            // If usage is below <1% value
            if (vm.donut.usage == 0) {
                vm.innerChartPercentage = 0 + '%';
                vm.data = [0, vm.balance];
                vm.donut.usage = '0';
            }

            if (vm.donut.usage >= 1) {
                vm.donut.usage = roundToOneDecimal(vm.donut.usage);
            }

            // Tooltips
            if (vm.donut.showTooltips) {
                var tooltip = {};
                tooltip.title = vm.donut.chartTitle + ' info';

                if (vm.donut.total > 0 && vm.donut.cals > 0) {
                    tooltip.content =
                        '<b>' +
                        vm.donut.planName +
                        ':</b> ' +
                        vm.donut.total +
                        '<br> <b>Perpetual:</b> ' +
                        vm.donut.cals;
                }
                if (vm.donut.total > 0 && vm.donut.cals == 0) {
                    tooltip.content =
                        '<b>' + vm.donut.planName + ':</b> ' + vm.donut.total;
                } else if (vm.donut.total <= 0 && vm.donut.cals > 0) {
                    // contains perpetual only
                    tooltip.content = '<b>Perpetual:</b> ' + vm.donut.cals;
                } else if (vm.donut.total == -1) {
                    // contains perpetual with unlimited Premium User ID
                    tooltip.content = '<b>Perpetual:</b> [Unlimited] ';
                }

                vm.tooltip = tooltip;
            }

            vm.showStaticUsage = vm.donut.showStaticUsage;
            if (vm.showStaticUsage) {
                vm.staticUsageUnknown = vm.donut.usageUnknownMessage;
                vm.staticActualUsage = vm.donut.actualUsage;
                vm.hasOlderVersion = vm.donut.hasOlderVersion;
                if (vm.hasOlderVersion) {
                    vm.staticActualUsage = 'Unknown';
                }
            }
        }
    }

    function change() {
        render();
    }

    function roundToOneDecimal(value) {
        return Math.round(value * 10) / 10;
    }
}



// WEBPACK FOOTER //
// ./modules/shared/asDoughnutChart/asDoughnutChart.component.js